export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    label: String,
    modelValue: Boolean,
    small: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['change', 'update:modelValue'],
  computed: {
    classIsChecked() {
      return this.modelValue ? 'checkbox__tick--checked' : '';
    },
    checkboxModifiers() {
      return {
        'checkbox--small': this.small,
      };
    },
  },
  methods: {
    onChange(e) {
      this.$emit('change', e.target.checked);
      this.$emit('update:modelValue', e.target.checked);
    },
  },
};
